import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiTableHead-root': {
			backgroundColor: '#fff',
		},
	},
	periodContent: {
		minWidth: '25vw',
	},
	status: {
		minWidth: '5vw',
	},
}));
